(function () {
  if (customElements.get('testimonials-slider')) return;

  class TestimonialsSlider extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-testimonials-viewport]');
      this.track = this.querySelector('[data-testimonials-track]');
      this.slides = Array.from(this.querySelectorAll('[data-testimonial-slide]'));
      this.dotsContainer = this.querySelector('[data-testimonial-dots]');
      this.dots = [];
      this.prevBtn = this.querySelector('[data-testimonial-prev]');
      this.nextBtn = this.querySelector('[data-testimonial-next]');

      if (!this.viewport || !this.track || this.slides.length < 2) return;

      this.autoplayEnabled = this.dataset.autoplay !== 'false';
      this.intervalMs = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.pageIndex = 0;
      this.timer = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.onPrev = this.goPrev.bind(this);
      this.onNext = this.goNext.bind(this);
      this.onResize = this.updateLayout.bind(this);
      this.onMouseEnter = this.pause.bind(this);
      this.onMouseLeave = this.resume.bind(this);
      this.onFocusIn = this.pause.bind(this);
      this.onFocusOut = this.handleFocusOut.bind(this);
      this.onVisibility = this.handleVisibility.bind(this);

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);

      this.buildDots = function () {
        if (!this.dotsContainer) return;

        if (this.pageCount < 2) {
          this.dotsContainer.hidden = true;
          this.dotsContainer.innerHTML = '';
          this.dots = [];
          return;
        }

        this.dotsContainer.hidden = false;
        this.dotsContainer.innerHTML = '';

        for (var i = 0; i < this.pageCount; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'testimonials-slider__dot' + (i === this.pageIndex ? ' is-active' : '');
          dot.setAttribute('data-testimonial-dot', '');
          dot.setAttribute('role', 'tab');
          dot.setAttribute('aria-selected', i === this.pageIndex ? 'true' : 'false');
          dot.setAttribute('aria-label', 'Anmeldelse ' + (i + 1));
          dot.addEventListener(
            'click',
            function (index) {
              this.goTo(index);
            }.bind(this, i)
          );
          this.dotsContainer.appendChild(dot);
        }

        this.dots = Array.from(this.dotsContainer.querySelectorAll('[data-testimonial-dot]'));
      }.bind(this);

      this.addEventListener('mouseenter', this.onMouseEnter);
      this.addEventListener('mouseleave', this.onMouseLeave);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      if (typeof IntersectionObserver !== 'undefined') {
        this.visibilityObserver = new IntersectionObserver(this.onVisibility, { threshold: 0.25 });
        this.visibilityObserver.observe(this);
      }

      this.reducedMotion.addEventListener('change', this.handleMotionPreference.bind(this));
      this.updateLayout();
      this.resume();
    }

    disconnectedCallback() {
      this.pause();
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.visibilityObserver) this.visibilityObserver.disconnect();
      window.removeEventListener('resize', this.onResize);
    }

    get slidesPerView() {
      var desktop = parseInt(this.dataset.slidesDesktop, 10) || 2;
      var mobile = parseInt(this.dataset.slidesMobile, 10) || 1;
      return window.innerWidth >= 990 ? desktop : window.innerWidth >= 750 ? Math.min(desktop, 2) : mobile;
    }

    get pageCount() {
      return Math.max(1, Math.ceil(this.slides.length / this.slidesPerView));
    }

    updateLayout() {
      var perView = this.slidesPerView;
      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      var viewportWidth = this.viewport.clientWidth;
      var slideWidth = (viewportWidth - gap * (perView - 1)) / perView;

      this.slides.forEach(function (slide) {
        slide.style.flexBasis = slideWidth + 'px';
        slide.style.maxWidth = slideWidth + 'px';
      });

      if (this.pageIndex >= this.pageCount) {
        this.pageIndex = 0;
      }

      this.buildDots();
      this.updateDots();
      this.scrollToPage(false);
    }

    scrollToPage(smooth) {
      var perView = this.slidesPerView;
      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      var slideWidth = this.slides[0] ? this.slides[0].offsetWidth : 0;
      var offset = this.pageIndex * (slideWidth + gap) * perView;

      this.track.scrollTo({
        left: offset,
        behavior: smooth && !this.reducedMotion.matches ? 'smooth' : 'auto',
      });

      this.updateDots();
    }

    updateDots() {
      this.dots.forEach(function (dot, index) {
        var isActive = index === this.pageIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
      }, this);
    }

    goTo(index) {
      this.pageIndex = index;
      this.scrollToPage(true);
      this.restartAutoplay();
    }

    goNext() {
      this.pageIndex = (this.pageIndex + 1) % this.pageCount;
      this.scrollToPage(true);
      this.restartAutoplay();
    }

    goPrev() {
      this.pageIndex = (this.pageIndex - 1 + this.pageCount) % this.pageCount;
      this.scrollToPage(true);
      this.restartAutoplay();
    }

    play() {
      if (!this.autoplayEnabled || this.reducedMotion.matches || this.pageCount < 2) return;
      this.pause();
      this.timer = window.setInterval(this.goNext.bind(this), this.intervalMs);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    resume() {
      if (document.hidden) return;
      this.play();
    }

    restartAutoplay() {
      this.pause();
      this.resume();
    }

    handleFocusOut(event) {
      if (this.contains(event.relatedTarget)) return;
      this.resume();
    }

    handleVisibility(entries) {
      var visible = entries.some(function (entry) {
        return entry.isIntersecting;
      });
      visible ? this.resume() : this.pause();
    }

    handleMotionPreference() {
      if (this.reducedMotion.matches) {
        this.pause();
      } else {
        this.resume();
      }
    }
  }

  customElements.define('testimonials-slider', TestimonialsSlider);
})();
